import { Grid, Typography, Box } from "@mui/material";
import FAQ from "../Common/FAQ";
import CustomBox from "../Common/CustomBox";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import { useState, useEffect, useMemo } from "react";
import { LoaderComponent } from "../../../../components/Loader/LoaderComponent";
import SpeedometerChart from "../SpeedoMeterChart";
import HeatmapChart from "../HeatMapChart";

const faqsStatic = [
  {
    content: "- Court Picture",
    status: "No",
  },
  {
    content: "- Court Map",
    status: "Yes",
  },
  {
    content: "- Case Status",
    status: "Yes",
  },
  {
    content: "- Court Order",
    status: "Yes",
  },
  {
    content: "- Case List",
    status: "Yes",
  },
  {
    content: "- Judges on Leave",
    status: "No",
  },
  {
    content: "- Calendar",
    status: "No",
  },
  {
    content: "- Circulars/Notice",
    status: "No",
  },
];

export const Website = ({ dataDistrict, selectedDistrict, stateData }) => {
  const { theme, loader, isSm, isXs, isXss } = useCustomLogic();

  let isDistrict = selectedDistrict === "Select District";

  const [faqs, setFaqs] = useState(faqsStatic);

  const normalizeYesNo = (value) => {
    if (value === null || value === undefined) return "No";
    const normalized = String(value).trim().toLowerCase();
    if (!normalized) return "No";
    if (["yes", "y", "true", "1"].includes(normalized)) return "Yes";
    if (["no", "n", "false", "0"].includes(normalized)) return "No";
    return value ? "Yes" : "No";
  };

  useEffect(() => {
    if (dataDistrict) {
      let arr = [
        dataDistrict?.picture ?? "",
        dataDistrict?.map ?? "",
        dataDistrict?.case_status ?? "",
        dataDistrict?.court_order ?? "",
        dataDistrict?.cause_list ?? "",
        dataDistrict?.judges_on_leave ?? "",
        dataDistrict?.calendar ?? "",
        dataDistrict?.notices ?? "",
      ];
      setFaqs(faqsStatic.map((item, index) => ({ ...item, status: normalizeYesNo(arr[index]) })));
    }
  }, [dataDistrict]);

  return (
    <>
      {loader ? (
        <LoaderComponent height="50vh" />
      ) : (
        <Box>
          {isDistrict ? (
            <Box>
              <Typography variant="regular3" color="secondary.main">
                Is the court website informative and useful?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: "10px",
                  textAlign: "left",
                  letterSpacing: "0.2px",
                  wordSpacing: "1px",
                }}
              >
                {/* District court websites are intended to be the primary source of
                information for litigants and lawyers, and were studied
                regarding the quality of information available relating to that
                court. */}
                For litigants and lawyers accessing individual court complexes, the court websites
                should have basic information relating to that court, such as the names of judges on
                leave, the court’s working calendar, an identifiable photograph of the court
                complex, and so on. The availability of essential information on the websites of the
                court complexes in the state was verified on 26.06.2018 (for Chandigarh) and
                03.07.2018 (for Punjab).
              </Typography>
              <Box
                style={{
                  display: "grid",
                  gridTemplateColumns: `repeat(${isXss ? 1 : isXs ? 2 : isSm ? 3 : 4}, 1fr)`,
                  gap: "50px 12px",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <SpeedometerChart meterTitle={"COURT PICTURE "} value={stateData?.picture} />
                <SpeedometerChart meterTitle={"COURT MAP "} value={stateData?.map} />
                <SpeedometerChart meterTitle={"CASE STATUS"} value={stateData?.case_status} />
                <SpeedometerChart meterTitle={"COURT ORDERS "} value={stateData?.court_order} />
                <SpeedometerChart meterTitle={"CAUSE LIST "} value={stateData?.cause_list} />
                <SpeedometerChart
                  meterTitle={"JUDGES ON LEAVE"}
                  value={stateData?.judges_on_leave}
                />
                <SpeedometerChart meterTitle={"CALENDER"} value={stateData?.calendar} />
                <SpeedometerChart meterTitle={"CIRCULARS/NOTICES"} value={stateData?.notices} />
              </Box>
            </Box>
          ) : (
            <>
              <CustomBox
                content="Is the court website informative and useful?"
                style={{
                  fontSize: "24px",
                  padding: "8px 13px",
                  color: theme.palette.common.black,
                  backgroundColor: "#e6ebf4",
                }}
              />

              <FAQ
                status=""
                content="Is the following information available?"
                style={{ fontStyle: "italic", fontWeight: "600" }}
              />
              {faqs &&
                faqs.map((item, index) => (
                  <FAQ
                    key={index}
                    content={item.content}
                    status={item.status}
                    isLastItem={index === faqs.length - 1}
                  />
                ))}
            </>
          )}
        </Box>
      )}
    </>
  );
};
